import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Text = styled(Typography.Header)`
  margin-top: 20px;
  margin-bottom: 15px;
`;

export const Subtitle = styled(Typography.Body)`
  margin-top: 5px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Invoice = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const Row = styled.div<{
  $is2Columns?: boolean;
  $isLast?: boolean;
  $hasBorders?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ $is2Columns }) =>
    $is2Columns ? '1fr 1fr' : '1fr 1fr 20px'};
  gap: 10px;
  align-items: center;
  margin-bottom: ${({ $isLast }) => ($isLast ? '0' : '15px')};

  ${({ $hasBorders, theme }) =>
    $hasBorders &&
    css`
      border-top: 1px solid ${() => theme.palette.primary.border};
      border-bottom: 1px solid ${() => theme.palette.primary.border};
      padding-block: 20px;
    `}
`;

export const PackageName = styled(Typography.Body)`
  margin-bottom: 5px;
`;

export const Number = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Price = styled(Typography.Title)`
  text-align: right;
  margin-bottom: 5px;
`;

export const Status = styled(Typography.Body)<{ $color: string }>`
  text-align: right;
  color: ${({ $color }) => $color};
`;

export const ImgBox = styled.div`
  justify-self: end;
`;

export const DownloadButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.system.lightBlue};
  padding-inline: 20px;
`;

export const PayDate = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.green};
  padding: 15px;
  text-align: center;
`;

export const Table = styled.div`
  padding: 25px 15px;
  margin: 0 15px;
  border-radius: 7px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Name = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)`
  text-align: right;
`;

export const TotalValue = styled(Typography.Title)`
  text-align: right;
`;
